import Vue from 'vue';
import _ from 'lodash';
import { resourcesService } from '@/main/services';
import {
	CHYBOVE_HLASKY, FORMULAR, GET_BY_KEY, GET_TEXT, GET_TEXT_FROM, GET_TEXT_NO_QUESTION_MARK,
	GET_ZKRATKA, MENU, POPIS_OSTATNI, POPIS_POLI,
} from '@/main/store/getterTypes';

import LocaleCs from '@/main/localization/resource_cs.json';
import LocaleEn from '@/main/localization/resource_en.json';
import LocaleZh from '@/main/localization/resource_zh.json';
// import { LocaleZh } from 'element-ui/lib/locale/lang/zh';

export const ZKRATKA_SUFFIX = '#ZKT';

type LocaleLanguage = typeof LocaleCs;
type LocaleLanguageCode = 'cs' | 'en' | 'zh';
interface Replacement {
	key: string;
	value: string;
}
export interface LocalizationMethods {
	Language: LocaleLanguageCode

	LocalizeMultiKey(multiKey: string): string

	LocalizeMultiKeyToCommaString(multiKey: string): string

	Localize(key: string): any

	LocalizeAndReplace(sText: string, { key, value }: { key:string, value: string }): string

	LocalizeAndReplaceMultiple(sText: string, replacements: Replacement[]): string

	LocalizeMenu(key: string): string

	LocalizePopisostatni(key: string): string

	LocalizePopisPoli(key: string): string

	LocalizeTitle(key: string): string

	LocalizeFrom(localizationType: string, key: string): string

	LocalizeFormular(key: string): string

	LocalizeChyboveHlasky(key: string): string

	LocalizeTextLong(key: string): Promise<string>

	LocalizeLocal(key: string): string
}

/**
 * New type of localizations based on local jsons
 */
const getCurrentLanguageMap = (language: 'cs' |'zh' | 'en' = 'cs'): LocaleLanguage => {
	const map = {
		cs: LocaleCs,
		en: LocaleEn,
		zh: LocaleZh,
	};

	return map[language];
};

export const localizeLocal = (key: string, language: 'cs' |'zh' | 'en') => _.get(getCurrentLanguageMap(language), key).Text;

export const LocalizationMixin = Vue.extend({
	computed: {
		Language(): string | null {
			return this.$store.state.localization.Language;
		},
	},
	methods: {
		LocalizeMultiKey(multiKey: string) {
			return multiKey.split('/').map(this.Localize).join(' ');
		},
		LocalizeMultiKeyToCommaString(multiKey: string) {
			return multiKey.split('/').map(this.Localize).join(', ');
		},
		Localize(key: string, options = { qustionMark: true }) {
			if (key.endsWith(ZKRATKA_SUFFIX)) {
				const zkratkaKey = key.slice(0, -ZKRATKA_SUFFIX.length);
				return this.$store.getters[GET_ZKRATKA](zkratkaKey);
			}
			return options.qustionMark ? this.$store.getters[GET_TEXT](key) : this.$store.getters[GET_TEXT_NO_QUESTION_MARK](key);
		},
		LocalizeAndReplace(sText: string, { key, value } : { key:string, value: string }) {
			// TODO: INDIA - this implementation is wrong. You should change LocalizeFrom (and all methods that use that method) so that it does the replacement
			// and we should be able to accept multiple key&value pairs
			// remove this method later
			return sText.replace(key, value);
		},
		// Method to accept multiple key value pairs to replace them in localiztion.
		LocalizeAndReplaceMultiple(sText: string, replacements: Replacement[]): string {
			let localizeText = sText;
			replacements.forEach(({ key, value }) => {
				localizeText = localizeText.replace(new RegExp(key, 'g'), value);
			});
			return localizeText;
		},
		LocalizeMenu(key: string) {
			return this.LocalizeFrom(MENU, key);
		},

		LocalizePopisostatni(key: string) {
			return this.LocalizeFrom(POPIS_OSTATNI, key);
		},

		LocalizePopisPoli(key: string) {
			return this.LocalizeFrom(POPIS_POLI, key);
		},

		LocalizeTitle(key: string) {
			const localis = this.$store.getters[GET_BY_KEY](POPIS_POLI, key)
				|| this.$store.getters[GET_BY_KEY](POPIS_OSTATNI, key);
			if (!localis) {
				return `??${key}`;
			}
			return localis.TextHint || localis.Text;
		},

		LocalizeFrom(localizationType: string, key: string) {
			return this.$store.getters[GET_TEXT_FROM](localizationType, key);
		},

		LocalizeFormular(key: string) {
			return this.LocalizeFrom(FORMULAR, key);
		},

		LocalizeChyboveHlasky(key: string) {
			return this.LocalizeFrom(CHYBOVE_HLASKY, key);
		},

		async LocalizeTextLong(key: string): Promise<string | null> {
			return resourcesService.loadTextLong(key);
		},

		/**
		 * New type of localizations based on local jsons
		 */
		LocalizeLocal(key: keyof LocaleLanguage) {
			const language = navigator.languages[0].split('-')[0] as 'cs' | 'zh' |'en'; // getting language from navigator because at this moment we do not have the loggedUser/language
			return localizeLocal(key, language);
		},
	},
});
